import React, {useEffect, useState} from 'react';
import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import Divider from '@/Atoms/Divider/Divider';
import Spacer from '@/Atoms/Spacer';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {ScreenName} from '@/navigators/StackConstants';
import CCColors from '@/Utils/CCColors';
import {setLocalStorage} from '@/Utils/CommonUtils';
import {FontSizes} from '@/Utils/Dimensions';
import {useNavigation} from '@react-navigation/native';
import {ScrollView, View, Image} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Pagination from '../Games/Pagination';

const StudentListComponent = ({
  relationKey,
  userRelationData,
  accessType,
  handleRequestAccess,
  setModifyMainMenu,
  searchTerm,
}) => {
  const {isMobileOrTab} = useMediaQuery();
  const navigation = useNavigation();
  const [currentPage, setCurrentPage] = useState(1);
  const [studentsPerPage] = useState(10);
  const [currentStudents, setCurrentStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);

  const titleHeaders = [
    {label: 'Player Details', key: 'playerDetails'},
    // {label: 'Phone Number', key: 'phoneNumber'},
    {label: 'User Name', key: 'userName'},
    {label: 'Access Granted of', key: 'accessGrantedOf'},
  ];

  const iconMapping = {
    Coach: 'school-outline',
    Parent: 'account-outline',
    Mentor: 'book-open-page-variant-outline',
  };

  const getInitials = (name: string): string => {
    if (!name || typeof name !== 'string') return '';

    const words = name.trim().split(' ').filter(Boolean);

    if (words.length === 0) {
      return '';
    }

    // One word: take first two characters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    const firstChar = words[0]?.[0] || '';
    const secondChar = words[1]?.[0] || words[2]?.[0] || words[0]?.[1] || '';

    return (firstChar + secondChar).toUpperCase();
  };
  useEffect(() => {
    // Step 1: Filter based on searchTerm
    const filtered =
      userRelationData?.filter(student =>
        student?.full_name?.toLowerCase().startsWith(searchTerm?.toLowerCase()),
      ) || [];

    setFilteredStudents(filtered);
    // Step 2: Paginate the filtered list
    const indexOfLastStudent = currentPage * studentsPerPage;
    const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
    const current = filtered?.slice(indexOfFirstStudent, indexOfLastStudent);

    setCurrentStudents(current);
  }, [currentPage, searchTerm, userRelationData]);

  const totalPages = Math.ceil(
    (filteredStudents?.length || 0) / studentsPerPage,
  );

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <>
      <ScrollView
        style={{
          margin: isMobileOrTab ? 10 : 0,
        }}
        showsVerticalScrollIndicator={false}>
        {userRelationData?.length > 0 ? (
          <>
            <Box type="row-center-between" style={{padding: 24}}>
              {titleHeaders.map(header => (
                <Box
                  key={header.key}
                  style={{flex: relationKey === 'Profile' ? 0.8 : 1}}>
                  <CCText
                    fontSize={FontSizes[14]}
                    color={CCColors.TextColor.Grey}
                    style={{lineHeight: 20, fontWeight: '500'}}>
                    {header.label}
                  </CCText>
                </Box>
              ))}
              <Box style={{width: relationKey === 'Profile' ? '18%' : 32}} />
            </Box>

            {currentStudents?.map((student, index) => (
              <React.Fragment key={student.user_id}>
                <Divider width={1} />
                <Box
                  key={index}
                  type="row-center-between"
                  style={{
                    paddingVertical: 24,
                    paddingHorizontal: 32,
                  }}>
                  <Box
                    type="row-flex-start"
                    style={{
                      gap: 12,
                      flex: relationKey === 'Profile' ? 0.8 : 1,
                    }}>
                    <View
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: 48,
                        backgroundColor: CCColors.CCTableBg,
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderWidth: 1,
                        borderColor: CCColors.TextColor.Grey,
                      }}>
                      <CCText
                        fontSize={FontSizes[24]}
                        style={{
                          lineHeight: 24,
                          fontWeight: '600',
                          fontFamily: 'Thunder',
                          marginBottom: -5,
                        }}>
                        {getInitials(student.full_name)}
                      </CCText>
                    </View>
                    <View>
                      <CCText
                        fontSize={FontSizes[16]}
                        style={{
                          lineHeight: 24,
                          fontWeight: '500',
                        }}
                        color={CCColors?.Primary?.Brown}>
                        {student.full_name}
                      </CCText>
                      {/* <CCText
                        fontSize={FontSizes[14]}
                        color={CCColors?.Primary?.Brown}
                        style={{lineHeight: 24, fontWeight: '400'}}>
                        {student.rating}{' '}
                        {student.level ? `| ${student.level}` : ''}
                      </CCText> */}
                    </View>
                  </Box>

                  {/* <Box style={{flex: relationKey === 'Profile' ? 0.8 : 1}}>
                  <CCText
                    fontSize={FontSizes[14]}
                    style={{lineHeight: 24, fontWeight: '500'}}
                    color={CCColors.TextColor.LightGrey}>
                    {student.phone}
                  </CCText>
                </Box> */}

                  <Box style={{flex: relationKey === 'Profile' ? 0.8 : 1}}>
                    <CCText
                      fontSize={FontSizes[14]}
                      style={{lineHeight: 24, fontWeight: '500'}}
                      color={CCColors.TextColor.LightGrey}>
                      {student.username}
                    </CCText>
                  </Box>

                  <Box style={{flex: relationKey === 'Profile' ? 0.8 : 1}}>
                    {Object.entries(accessType).map(([role, students]) => {
                      const isMatch = students.some(
                        s => s.user_id === student.user_id,
                      );
                      if (!isMatch) return null;

                      return (
                        <View
                          key={role}
                          style={{
                            borderWidth: 1,
                            borderColor: CCColors?.Box?.MiddleLine,
                            paddingHorizontal: 12,
                            paddingVertical: 4,
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 6,
                            borderRadius: 12,
                            alignSelf: 'flex-start',
                          }}>
                          <MaterialCommunityIcons
                            name={iconMapping[role]}
                            size={20}
                            color={CCColors.TextColor.LightGrey}
                          />
                          <CCText
                            fontSize={FontSizes[14]}
                            style={{lineHeight: 24, fontWeight: '500'}}
                            color={CCColors.TextColor.LightGrey}>
                            {role}
                          </CCText>
                        </View>
                      );
                    })}
                  </Box>
                  <View
                    style={{
                      width: relationKey === 'Profile' ? '18%' : 32,
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}>
                    {relationKey === 'Profile' ? (
                      // <CCButton
                      //   style={{
                      //     borderWidth: 1,
                      //     borderColor: CCColors?.BorderBottom,
                      //     backgroundColor: CCColors.White,
                      //   }}>
                      //   <CCText
                      //     fontSize={FontSizes[14]}
                      //     color={CCColors?.WrongMoves?.Background}>
                      //     Revoke Access
                      //   </CCText>
                      // </CCButton>
                      <></>
                    ) : (
                      <Box
                        onPress={async () => {
                          await setLocalStorage(
                            'user_key',
                            `${student?.user_key}`,
                          );
                          await setLocalStorage(
                            'reports_user_id',
                            `${student?.user_id}`,
                          );
                          await setLocalStorage(
                            'profile_access',
                            student?.full_name,
                          );
                          setModifyMainMenu(true);
                          navigation.navigate(ScreenName.AssessmentReport, {
                            user_key: `${student?.user_key}`,
                          });
                        }}
                        style={{
                          backgroundColor: CCColors.Primary.Action,
                          width: 32,
                          height: 32,
                          borderRadius: 32,
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                        <MaterialCommunityIcons
                          name="eye-outline"
                          size={16}
                          style={{
                            color: CCColors.TextColor.Dark,
                          }}
                        />
                      </Box>
                    )}
                  </View>
                </Box>
              </React.Fragment>
            ))}
          </>
        ) : (
          <View style={{alignItems: 'center', justifyContent: 'center'}}>
            <Image
              source={require('@/Assets/Images/RequestAccess/NoPlayer.svg')}
              alt="No Students Found"
              style={{width: 180, height: 180, marginBottom: 20}}
              resizeMode="contain"
            />
            <Spacer spacing={20} />
            <CCText
              fontSize={FontSizes[16]}
              color={CCColors?.TextColor?.Dark}
              style={{lineHeight: 20, fontWeight: '500'}}>
              No player access added to your profile yet
            </CCText>
            <Spacer spacing={10} />
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors?.TextColor?.Primary}
              style={{
                lineHeight: 20,
                fontWeight: '400',
                textAlign: 'center',
              }}>
              Click the CTA below to request player{'\n'}profile access
            </CCText>
            <Spacer spacing={20} />
            <CCButton
              titleStyle={{
                fontSize: FontSizes[16],
                color: CCColors.TextColor.Primary,
              }}
              style={{backgroundColor: CCColors.Primary.Action}}
              onPress={handleRequestAccess}>
              + Request Access
            </CCButton>
          </View>
        )}
      </ScrollView>
      {currentStudents?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          paginate={paginate}
        />
      )}
    </>
  );
};

export default StudentListComponent;
